import fetcher from 'api/fetcher';

import { translate } from 'hooks/translation/useTrls';

import { removeBannerFromModerationList } from 'store/models/moderation';
import { addMagritteCustomNotification, MagritteNotificationType } from 'store/models/notification';
import { AppThunkAction } from 'store/utils';

const approveBanner = (bannerId: number, campaignId: number): AppThunkAction<void> => {
    return (dispatch, getState) => {
        const trls = getState().translations.trls;

        void fetcher
            .post(`/api/v1/moderation/approve/${bannerId}`)
            .then(() => {
                dispatch(removeBannerFromModerationList({ campaignId, bannerId }));
                dispatch(
                    addMagritteCustomNotification({
                        type: MagritteNotificationType.Success,
                        text: translate(trls, 'admin.moderation.banner.approve.notification', [bannerId]),
                    })
                );
            })
            .catch(() => {
                dispatch(
                    addMagritteCustomNotification({
                        type: MagritteNotificationType.Error,
                        text: translate(trls, 'admin.moderation.banner.error.notification', [bannerId]),
                    })
                );
            });
    };
};

export { approveBanner };
